import type { User } from "@blocknote/core";
import { IScriptingComment } from "@shared/lib/types/briefCampains";
import { getCommentQuote, getCommentThreadId } from "./commentAnchor";
import { ScriptCommentThreadStore } from "./scriptCommentThreadStore";

export const uniqueCommentUsers = (users: User[]) => {
  const byId = new Map<string, User>();
  users.forEach((user) => {
    if (user.id) byId.set(user.id, user);
  });
  return Array.from(byId.values());
};

export const anchorsFromComments = (
  comments: IScriptingComment[],
  threadStore: ScriptCommentThreadStore
) =>
  comments.flatMap((comment) => {
    const threadId = getCommentThreadId(comment);
    const quote = getCommentQuote(comment);
    if (!threadId || !quote) return [];
    threadStore.ensureThread(threadId);
    return [{ threadId, quote }];
  });
